class CartTerms extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('.cart-check > input[type="checkbox"]');
    this.captions = this.querySelectorAll('.caption');
    this.parent = this.parentElement;
  }

  connectedCallback() {
    const cartBtn = this.parent.querySelector('button[name="checkout"]');
    if (cartBtn) {
      // cartBtn.classList.toggle('hidden', !this.checkBoxes());
      cartBtn.toggleAttribute('disabled', !this.checkBoxes());
      this.inputs.forEach((el) => {
        const errors = this.parent.querySelector('#cart-errors');
        el.addEventListener('change', () => {
          // cartBtn.classList.toggle('hidden', !this.checkBoxes());
          cartBtn.toggleAttribute('disabled', !this.checkBoxes());
          this.captions.forEach((el) => {
            el.classList.toggle('hidden', this.checkBoxes());
          });
          if (errors?.textContent === '同意事項を確認してください') errors.textContent = '';
        });
      });

      // show error if cart button is somehow enabled and clicked but checkbox is not checked
      cartBtn.addEventListener('click', (e) => {
        const errors = this.parent.querySelector('#cart-errors');
        if (!this.checkBoxes()) {
          e.preventDefault();
          if (errors && !errors.textContent) errors.textContent = '同意事項を確認してください';
        }
      });
    }
  }

  // returns true if both boxes are checked
  checkBoxes() {
    const checkedBoxes = this.querySelectorAll('.cart-check > input[type="checkbox"]:checked');
    if (checkedBoxes) {
      return this.inputs.length === checkedBoxes.length;
    } else {
      return false;
    }
  }
}

customElements.define('cart-terms', CartTerms);
